import { getOAuthsEnabled } from '../flow-initial/getFlowConfig';
export const useOAuthSignup = () => {
  const oAuthsEnabledByFlowConfig = getOAuthsEnabled();
  const atLeastOneOAuthEnabled = Object.values(oAuthsEnabledByFlowConfig).some(value => value);
  return {
    oAuthsEnabledByFlowConfig,
    atLeastOneOAuthEnabled
  };
};